import React, { useState, useEffect } from 'react';
import { Typography, Link } from '@mui/material';

const Footer = () => {
    const [buildInfo, setBuildInfo] = useState(null);

    useEffect(() => {
        // Load build info
        fetch('/build-info.json')
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return null;
            })
            .then(data => {
                setBuildInfo(data);
            })
            .catch(() => {
                // Ignore errors, build info is optional
            });
    }, []);

    const versionText = buildInfo?.gitTag && buildInfo.gitTag !== 'unknown'
        ? `V 4.0.4 mit Build ${buildInfo.gitTag}`
        : 'V 4.0.4';

    return (
        <div style={{ marginBottom: '20px' }}>
            <Typography variant="body2" color="textSecondary" align="center">
                {'© '}{' ' + new Date().getFullYear()} {' '}
                <Link color="inherit" href="https://www.coderis.de">
                    coderis GmbH
                </Link>
                {' | '}
                <Link color="inherit" href="/impressum">
                    Impressum
                </Link>
                {' | '}
                <Link color="inherit" href="/datenschutz">
                    Datenschutz
                </Link>
                {' | '}
                <Link color="inherit" href="/agb">
                    AGBs
                </Link>
                {' | ' + versionText}
            </Typography>
        </div>
    );
}

export default Footer;